export default __webpack_public_path__ + "static/media/58_desktop.d9d5f20b.jpg";